<script>
  import CopyButton from "./CopyButton.svelte";

  export let maxWidth = "100%";
  export let encodingHex;
  export let small = false;
</script>

<div class="copy-row">
  <span
    class="encoding-hex reselect"
    class:small
    alt={encodingHex}
    style={`max-width: ${maxWidth}`}>{encodingHex ? encodingHex : "..."}</span
  >
  {#if encodingHex}
    <CopyButton label="Encoding" {small} value={encodingHex}></CopyButton>
  {/if}
</div>

<style>
  .small {
    font-size: 12px;
  }
  .encoding-hex {
    width: 100%;
    box-sizing: border-box;
    user-select: initial;
    pointer-events: initial;
    touch-action: initial;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .copy-row {
    display: flex;
    gap: 5px;
    align-items: center;
    /* flex-grow: 0; */
    width: 100%;
  }
</style>
